import React, { useCallback, useEffect, useState } from 'react';

interface OpenModalOptions {
  // Scroll the modal to the consequence formula inputs once it has loaded.
  scrollToFormula?: boolean;
}

interface ScenarioContextInterface {
  id: string | undefined;
  isOpen: boolean;
  scrollToFormula: boolean;
  openModal: (id?: string | number, options?: OpenModalOptions) => void;
  closeModal: () => void;
}

const ScenarioContext = React.createContext<Partial<ScenarioContextInterface>>({});

const ScenarioProvider = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState<string | number | undefined>(undefined);
  const [scrollToFormula, setScrollToFormula] = useState(false);
  const openModal = useCallback(
    (id?: string | number, options?: OpenModalOptions) => {
      if (id) {
        setId(id);
      }
      setScrollToFormula(!!options?.scrollToFormula);
      setIsOpen(true);
    },
    [setIsOpen],
  );
  useEffect(() => {
    if (!isOpen) {
      setId(undefined);
      setScrollToFormula(false);
    }
  }, [isOpen]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <ScenarioContext.Provider
      value={{
        isOpen,
        scrollToFormula,
        openModal,
        closeModal,
        id,
      }}
      {...props}
    />
  );
};

const useScenario = () => {
  const context = React.useContext(ScenarioContext);
  if (context === undefined) {
    throw new Error('useScenario must be used within a ScenarioProvider');
  }
  return context as ScenarioContextInterface;
};

export { ScenarioProvider, useScenario };
